<template>
  <div class="carousel-container">
    <div class="carousel-wrapper">
      <div 
        class="carousel-track" 
        :style="{ transform: `translateX(-${currentIndex * (100 / logosPerSlide)}%)` }"
      >
        <div 
          v-for="(logo, index) in duplicatedLogos" 
          :key="`${logo}-${index}`"
          class="carousel-slide"
        >
          <img loading="lazy" 
            :src="getLogoPath(logo)" 
            :alt="`Logo ${logo.split('.')[0]}`"
            class="client-logo"
          />
        </div>
      </div>
    </div>
    
    <!-- Controles de navegación -->
    <button 
      class="carousel-btn carousel-btn-prev" 
      @click="prevSlide"
      aria-label="Anterior"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    
    <button 
      class="carousel-btn carousel-btn-next" 
      @click="nextSlide"
      aria-label="Siguiente"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CarouselClientes',
  data() {
    return {
      currentIndex: 0,
      logosPerSlide: 5,
      autoPlayInterval: null
    }
  },
  computed: {
    ...mapGetters(['getClientLogos']),
    duplicatedLogos() {
      // Duplicamos los logos para crear un efecto de carrusel infinito
      return [...this.getClientLogos, ...this.getClientLogos]
    }
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeUnmount() {
    this.stopAutoPlay()
  },
  methods: {
    getLogoPath(logoName) {
  
        return require(`@/assets/logos/clients-logos/${logoName}`)
      
    },
    nextSlide() {
      this.currentIndex++
      if (this.currentIndex >= this.getClientLogos.length) {
        this.currentIndex = 0
      }
    },
    prevSlide() {
      this.currentIndex--
      if (this.currentIndex < 0) {
        this.currentIndex = this.getClientLogos.length - 1
      }
    },
    startAutoPlay() {
      this.autoPlayInterval = setInterval(() => {
        this.nextSlide()
      }, 3000) // Cambia cada 3 segundos
    },
    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval)
        this.autoPlayInterval = null
      }
    }
  }
}
</script>

